<template>
  <div>
    <div class="box-now-map-widget-container">
      <a ref="widgetElementOpenButton" href="javascript:void(0)" class="boxnow-map-widget-button"></a>
      <div v-show="getSelectedTransporterObject && getSelectedTransporterObject.class_name === transporter.class_name" id="boxnowmap"></div>
    </div>
    <div v-if="getSmartPointIsSelected" class="smart_point-selection-input">
      <input type="hidden" name="smartPointJsonData" :value="JSON.stringify(getSelectedSmartPoint)">
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import store from '../../../../vue/store'
import SmartPointModelDTO from '../SmartPointModelDTO'

export default {
  name: 'BoxNowWidget',
  props: {
    transporter: {
      type: Object,
      required: true
    }
  },
  created () {
    this.$root.$on(`${this.transporter.class_name}_AfterSelect`, (payload) => {
      const smartPoint = new SmartPointModelDTO(
        payload.boxnowLockerId,
        payload.boxnowLockerName,
        payload.boxnowLockerAddressLine1 + ' ' + payload.boxnowLockerAddressLine2,
        '',
        payload.boxnowLockerLat,
        payload.boxnowLockerLng,
        payload.boxnowLockerPostalCode
      )
      store.dispatch('setSelectedSmartPoint', smartPoint).then(() => {
        this.$root.$emit(`${this.transporter.class_name}_WidgetClose`)
      }).then(() => {
        this.$toasted.success(
          this.t('pickup.point.selected'), { duration: '2500' }
        )
      })
    })
    this.$root.$on(`${this.transporter.class_name}_WidgetOpen`, () => {
      this.clickOpenWidgetElement()
    })
  },
  destroyed () {
    this.$root.$off(`${this.transporter.class_name}_AfterSelect`)
    this.$root.$off(`${this.transporter.class_name}_WidgetOpen`)
  },
  computed: {
    ...mapGetters([
      'getSelectedSmartPoint',
      'getSelectedTransporterObject',
      'isSmartPointWidgetInitialized',
      'getSmartPointIsSelected'
    ])
  },
  methods: {
    addSelectedData (payload) {
      this.$set(this, 'selectedData', payload)
    },
    clickOpenWidgetElement () {
      if (this.$refs.widgetElementOpenButton) {
        if (this.isSmartPointWidgetInitialized(this.transporter.class_name)) {
          // the box now script is already loaded, so we just need to call the function of the script
          window._bnclient_map_widget()
        }
        this.$refs.widgetElementOpenButton.click()
      }
    }
  }
}
</script>

<style lang="scss">
  #boxnowmap {
    iframe {
      z-index: 999999;
      top: 0;
      left: 0;
      display: flex;
      min-height: 100%;
      position: absolute;
      backdrop-filter: blur(1rem);
    }
  }
  .boxnow-map-widget-button {
    display: none;
  }
</style>
